import { youMustConfirm, youHaveRead } from "../utils/common";
var VARIANTS = {
  ARHI: youHaveRead("Fund Rules"),
  GU: youHaveRead("Fund Rules"),
  IMAN: youHaveRead("Fund Rules, Duty of Disclosure and Direct Debit Service Agreement"),
  IWHI: youHaveRead("Fund Rules, Duty of Disclosure and Direct Debit Service Agreement"),
  ISHI: youHaveRead("Privacy Policy and Fund Rules")
};
var validFundsRulesConfirmedCheckbox = function validFundsRulesConfirmedCheckbox(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var error; // eslint-disable-line init-declarations
  if (!value) {
    error = youMustConfirm(VARIANTS[funnel] || VARIANTS.ARHI);
  }
  return error;
};
export default validFundsRulesConfirmedCheckbox;